import {makeVar} from "@apollo/client";

export const loadPlaybackHistory = makeVar(null);
export const setPlaybackAnimationOnOff = makeVar({});
export const setPlaybackTripIndex = makeVar(null);